import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSFamiliaMaterialService from '@/services/SistemaDKP/SLSFamiliaMaterial.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSFamiliaMaterialService = new SLSFamiliaMaterialService();
  const refFamiliaMaterialListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'familia_material_id', label: 'Codigo', sortable: false },
    { key: 'familia_material_descricao', label: 'Descrição', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalFamiliaMaterial = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('familia_material_id');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refFamiliaMaterialListTable.value ? refFamiliaMaterialListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalFamiliaMaterial.value,
    };
  });

  const refetchData = () => {
    refFamiliaMaterialListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchFamiliaMaterial = (ctx, callback) => {
    overlay.value = true;
    sLSFamiliaMaterialService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalFamiliaMaterial.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const createOrUpdated = async (body) => {
    if (body.familia_material_id) {
      await sLSFamiliaMaterialService.update(body.familia_material_id, body);
    } else {
      await sLSFamiliaMaterialService.store(body);
    }
    refetchData();
  };

  const removerData = async (id) => {
    await sLSFamiliaMaterialService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchFamiliaMaterial,
    tableColumns,
    perPage,
    currentPage,
    totalFamiliaMaterial,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refFamiliaMaterialListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    createOrUpdated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
